export const INTERNAL_SERVER_ERROR = 'Something went wrong, try again later.'